import appInfo from "../app-info";

export default {
    apiURL: appInfo.apiURL,
    appURL: appInfo.appURL,
    timeout: 1000,

    authHeader () {
        let user = JSON.parse(localStorage.getItem('userInfo'));
        if (user?.accessToken) {
            // for Node.js Express back-end
            return { 
            'x-access-token': user.accessToken,
            'Content-type': 'application/json'
            };
        } else {
            return { 
            'Content-type': 'application/json'
            };
        }
    },

    connData(extraConfig) {
        return {...{
          baseURL: this.apiURL,
          headers: this.authHeader(),
        }, ...extraConfig}
    }
};
